import Form from './container/Form'
import reducer from './reducer'

export { Form, reducer }



// WEBPACK FOOTER //
// ./client/Modules/Captcha/index.js